<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs"
    :key="isSmallerScreen">
    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-settings" :label="!isSmallerScreen ? 'System' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <vx-card>
          <h6 class="mb-4">Setting System</h6>
          <vs-table search stripe :data="system">
            <template slot="thead">
              <vs-th>name</vs-th>
              <vs-th>web</vs-th>
              <vs-th>setting</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="tr.setting_name">
                  {{tr.setting_name}}
                </vs-td>
                <vs-td :data="tr.from_website">
                  {{tr.from_website}}
                </vs-td>
                <vs-td :data="tr.setting_status">
                  <vs-switch :disabled="$store.state.AppActiveUser.permissions.setting.action ? false : true" v-model="tr.setting_status" @click="update_status(tr.setting_no,tr.setting_status,tr.setting_name,'System')">
                    <span slot="on">เปิด</span>
                    <span slot="off">ปิด</span>
                  </vs-switch>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </vs-tab>
    <!-- BONUS -->
    <vs-tab icon-pack="feather" icon="icon-star" :label="!isSmallerScreen ? 'Bonus' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <vx-card>
          <h6 class="mb-4">Setting Bonus </h6>
          <vs-table stripe :data="bonus">

            <template slot="thead">
              <vs-th>name</vs-th>
              <vs-th>web</vs-th>
              <vs-th>เปิด-ปิด ปุ่มรับโบนัส</vs-th>
              <vs-th>เปิด-ปิด การโชว์โบนัส</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="tr.bonus_name">
                  {{tr.bonus_name}}
                </vs-td>
                <vs-td :data="tr.from_website">
                  {{tr.from_website}}
                </vs-td>
                <vs-td :data="tr.bonus_button">
                  <vs-switch :disabled="$store.state.AppActiveUser.permissions.setting.action ? false : true" v-model="tr.bonus_button" @click="update_status(tr.bonus_id,tr.bonus_button,tr.bonus_name,'Bonus')">
                    <span slot="on">เปิด</span>
                    <span slot="off">ปิด</span>
                  </vs-switch>
                </vs-td>
                <vs-td :data="tr.bonus_open">
                  <vs-switch :disabled="$store.state.AppActiveUser.permissions.setting.action ? false : true" v-model="tr.bonus_open" @click="update_status(tr.bonus_id,tr.bonus_open,tr.bonus_name,'Bonus_open')">
                    <span slot="on">เปิด</span>
                    <span slot="off">ปิด</span>
                  </vs-switch>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </vs-tab>
    <!-- LINE -->
    <vs-tab icon-pack="feather" icon="icon-message-circle" :label="!isSmallerScreen ? 'LinkLine' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <vx-card>
          <h6 class="mb-4">Setting LinkLine </h6>
          <br>

          <vs-table stripe :data="line">

          <template slot="thead">
            <vs-th>name</vs-th>
            <vs-th>setting</vs-th>
            <vs-th>เปิด-ปิด การโชว์</vs-th>
            <vs-th></vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="tr.description">
                {{tr.description}}
              </vs-td>
              <vs-td :data="tr.value">
                <vs-input class="w-full " v-validate="'required'" label-placeholder="value" v-model="tr.value" name="link"></vs-input>
              </vs-td>
              <vs-td :data="tr.status">
                  <vs-switch v-if="tr.type === 'link' || tr.type === 'link2' || tr.type === 'link_telegram'" :disabled="$store.state.AppActiveUser.permissions.setting.action ? false : true" v-model="tr.status" @click="save(tr.type,tr.value,tr.description,tr.from_website,tr.status)">
                    <span slot="on">เปิด</span>
                    <span slot="off">ปิด</span>
                  </vs-switch>
               </vs-td>
              <vs-button :disabled="$store.state.AppActiveUser.permissions.setting.action ? false : true" class="ml-auto mt-2" color="success" @click="save(tr.type,tr.value,tr.description,tr.from_website,tr.status)" >บันทึก</vs-button>

            </vs-tr>
          </template>
          </vs-table>
        </vx-card>
      </div>
    </vs-tab>
    <!-- SETTING ALL WEB -->
    <vs-tab icon-pack="feather" icon="icon-settings" :label="!isSmallerScreen ? 'All Website' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <vx-card>
          <h6 class="mb-4">All Website</h6>
          <vs-table stripe :data="all">
            <template slot="thead">
              <vs-th>name</vs-th>
              <vs-th>setting</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="tr.setting_name">
                  {{tr.setting_name}}
                </vs-td>
                <vs-td :data="tr.setting_status">
                  <vs-switch :disabled="$store.state.AppActiveUser.permissions.setting.action ? false : true" v-model="tr.setting_status" @click="update_status(tr.setting_no,tr.setting_status,tr.setting_name,'All Website')">
                    <span slot="on">เปิด</span>
                    <span slot="off">ปิด</span>
                  </vs-switch>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </vs-tab>
    <!-- UFA LINK -->
    <vs-tab icon-pack="feather" icon="icon-link" :label="!isSmallerScreen ? 'UFA Link' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <vs-td>
          <vs-button :disabled="$store.state.AppActiveUser.permissions.setting.action ? false : true"
            type="border"
            size="small"
            icon-pack="feather"
            icon="icon-edit"
            class="mr-2 mb-4"
            @click="clearData(), popupInfoLink('add')">เพิ่มลิงค์ UFA</vs-button>
        </vs-td>
        <vx-card title="แก้ไขลิงค์ UFA">
          <vs-table :data="linkUfa">
            <template slot="thead">
              <vs-th>NAME</vs-th>
              <vs-th>URl</vs-th>
              <vs-th>URl Mobile</vs-th>
              <vs-th>ICON</vs-th>
              <vs-th>STATUS</vs-th>
              <vs-th></vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="tr.text">{{ tr.text }}</vs-td>
                <vs-td :data="tr.url">{{ tr.url }}</vs-td>
                <vs-td :data="tr.urlMobile">{{ tr.urlMobile }}</vs-td>
                <vs-td :data="tr.icon">{{ tr.icon }}</vs-td>
                <vs-td :data="tr.status">
                  <vs-switch
                    :disabled="$store.state.AppActiveUser.permissions.setting.action ? false : true"
                    v-model="tr.status"
                    :value="true"
                    :unchecked-value="false"
                    @input="confirm_edit('edit',tr.id,tr.status,tr.icon,tr.text,tr.url,tr.urlMobile)">
                    <span slot="on">เปิด</span>
                    <span slot="off">ปิด</span>
                  </vs-switch>
                </vs-td>
                <vs-td>
                  <div class="flex items-center justify-end">
                    <vs-button :disabled="$store.state.AppActiveUser.permissions.setting.action ? false : true"
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="mr-2"
                      @click="popupInfoLink('edit', tr)">แก้ไข</vs-button>
                    <vs-button :disabled="$store.state.AppActiveUser.permissions.setting.action ? false : true"
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-trash"
                      @click="popupInfoLink('delete', tr)">ลบ</vs-button>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>

        <vs-popup classContent="popup-example" :title="`${infopopup.type} URl`" :active.sync="showpopup">
          <vs-input class="w-full" label-placeholder="URl" v-model="infopopup.url" type="text" name="url" :disabled="infopopup.type === 'delete'" />
          <br>
          <vs-input class="w-full" label-placeholder="URl Mobile" v-model="infopopup.urlMobile" type="text" name="url" :disabled="infopopup.type === 'delete'" />
          <br>
          <vs-input class="w-full" label-placeholder="TEXT" v-model="infopopup.text" type="text" name="text" :disabled="infopopup.type === 'delete'" />
          <br>
          <vs-input class="w-full" label-placeholder="ICON" v-model="infopopup.icon" type="text" name="icon" :disabled="infopopup.type === 'delete'" />
          <br>
          <vs-button :disabled="$store.state.AppActiveUser.permissions.setting.action ? false : true"
            size="small"
            icon-pack="feather"
            icon="icon-edit"
            class="mr-2 mt-4"
            @click="confirm_edit(infopopup.type, infopopup.id, infopopup.status, infopopup.icon, infopopup.text, infopopup.url, infopopup.urlMobile)">ยืนยัน</vs-button>
        </vs-popup>
      </div>
    </vs-tab>
  </vs-tabs>


</template>

<script>
import axios from '../../axios'


export default {
  data () {
    return {
      game: [],
      system: [],
      bonus: [],
      tset:'',
      line:[],
      all: [],
      onoff_status:{},
      lnikLineResponse:{},
      VUE_APP_TITLE: null,
      data:'',
      linkUfa: '',
      showpopup: false,
      infopopup: {
        id: '',
        url: '',
        urlMobile: '',
        text: '',
        icon: '',
        type: ''
      }

    }
  },
  async mounted () {
    this.VUE_APP_TITLE = process.env.VUE_APP_TITLE
    await this.getData(this.currentWebsite.value)
    await this.callinfo()
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    },
    currentWebsite () {
      return this.$store.state.currentWebsite
    }
  },
  watch: {
    currentWebsite (newWebsite, oldWebsite) {
      if (newWebsite.value !== oldWebsite.value) {
        // Put get data function here
        this.getData(this.currentWebsite.value)
      }
    }
  },
  methods: {
    async getData (value) {
      await axios
        .get(`settingsystem/settingsystem/system/${value}`)
        .then((response) => (this.system = response.data))
      await axios
        .get(`settingsystem/settingsystem/bonus/${value}`)
        .then((response) => (this.bonus = response.data))
      await axios
        .get(`settingsystem/settingline/${value}`)
        .then(response => (this.line = response.data))
      await axios
        .get('settingsystem/settingsystem/all/all')
        .then((response) => (this.all = response.data))
    },
    async save (type, value, description, from_website, status) {
      if (status === true) {
        status = false
      } else {
        status = true
      }
      await axios
        .post('settingsystem/systemlineupdate', {
          type,
          value,
          status,
          from_website
        }).then(response => (this.lnikLineResponse = response.data))
      if (this.lnikLineResponse.status === true) {
        this.$vs.notify({
          time:3000,
          color: 'success',
          position:'top-right',
          icon:  'check_box',
          title: 'แก้ไขสำเร็จ',
          text: `สถานะ : ${status === true ? 'เปิดใช้งาน' : 'ปิดใช้งาน'} ${description}ที่แก้ไข : ${value} (FROM : ${this.currentWebsite.value})`
        })

      } else {
        this.$vs.notify({
          time:8000,
          color: 'danger',
          position:'top-right',
          icon:  'error',
          title: 'แก้ไขไม่สำเร็จ',
          text: 'กรุณาติดต่อทีมงานโปรแกรมเมอร์'
        })
      }
    },
    async update_status (setting_no, setting_status, setting_name, system_name) {
      // console.log('setting_no', setting_no, 'setting_status', setting_status, 'setting_name', setting_name)
      if (setting_status === true) {
        setting_status = false
      } else {
        setting_status = true
      }
      await axios
        .post('settingsystem/systemstatus', {
          no:setting_no,
          status:setting_status,
          name:setting_name,
          bonus:system_name
        }).then(response => (this.onoff_status = response.data))
      if (this.onoff_status.status === true) {
        const fromWebsite = `(FROM : ${this.currentWebsite.value})`

        this.$vs.notify({
          time:3000,
          color: setting_status === true ? 'success' : 'warning',
          position:'top-right',
          icon:  setting_status === true ? 'check_box' : 'error',
          title: setting_status === true ? 'เปิด' : 'ปิด',
          text:  setting_status === true ? `ระบบ : ${setting_name} ${fromWebsite}` : `ระบบ : ${setting_name} ${fromWebsite}`
        })

      } else {
        this.$vs.notify({
          time:8000,
          color: 'danger',
          position:'top-right',
          icon:  'error',
          title: this.onoff_status.status === false ? 'เปิดระบบ หน้าเว็บไม่สำเร็จ!!' : 'ปิดระบบ หน้าเว็บไม่สำเร็จ!!',
          text: 'กรุณาติดต่อทีมงานโปรแกรมเมอร์'
        })
        if (setting_status === true) {
          setting_status = true
        } else if (setting_status === false) {
          setting_status = false
        }
      }
    },
    async update_status_linkLine (id, status) {
      if (status === true) {
        status = false
      } else {
        status = true
      }
      console.log('id', id, 'status', status)
    },
    async callinfo () {
      const response = await axios.get('/setting-ufa/getufalink')
      this.linkUfa = response.data
    },
    popupInfoLink (Type, tr) {
      if (Type === 'edit' || Type === 'delete') {
        this.infopopup.id = tr.id
        this.infopopup.url = tr.url
        this.infopopup.urlMobile = tr.urlMobile
        this.infopopup.text = tr.text
        this.infopopup.icon = tr.icon
        this.showpopup = true
      } else {
        this.showpopup = true
      }
      this.infopopup.type = Type
    },
    async confirm_edit (type, id, status, icon, text, url, urlMobile) {
      if (type === 'edit') {
        await axios.post('/setting-ufa/updateLink', {
          id,
          url,
          urlMobile,
          text,
          icon,
          status
        })
          .then(response => (this.error = response.data))
      }
      if (type === 'add') {
        await axios.post('/setting-ufa/addLink', {
          url,
          urlMobile,
          text,
          icon
        })
          .then(response => (this.error = response.data))
      }
      if (type === 'delete') {
        await axios.post('/setting-ufa/deleteLink', {
          id
        })
          .then(response => (this.error = response.data))
      }
      if (this.error.status === true) {
        this.$vs.notify({
          time: 10000,
          color: 'success',
          position: 'top-right',
          icon: 'error',
          text: this.error.info,
          title: 'ทำรายการสำเร็จ'
        })
        this.callinfo()
        this.showpopup = false
      } else {
        this.$vs.notify({
          time: 10000,
          color: 'danger',
          position: 'top-right',
          icon: 'error',
          text: this.error.info,
          title: 'ทำรายการผิดพลาด'
        })
        this.showpopup = false
      }
    },
    clearData () {
      this.infopopup.url = ''
      this.infopopup.urlMobile = ''
      this.infopopup.text = ''
      this.infopopup.icon = ''
    }
  }

}

</script>

<style lang="scss">
  #profile-tabs {
    .vs-tabs--content {
      padding: 0;
    }
  }

</style>
